
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, ElementRef, inject, ViewChild } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Genre } from '@shared/interfacres/genre';
import { MatButton } from '@angular/material/button';
import { NgOptimizedImage } from '@angular/common';
import { TracksManagerService } from '@data-access/manager/services/tracks-manager.service';
import { map } from 'rxjs/operators';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { MatProgressBar } from '@angular/material/progress-bar';
import { TrackApiData, TrackData } from '@shared/interfacres/track';
import { EditTrackComponent } from '../edit-track-component/edit-track-component';
import { TrackModel } from '../manage-track-dialog/manage-track-dialog';

const MAX_FILES_ALLOWED = 20;

@Component({
  selector: 'app-upload-bulk',
  templateUrl: 'upload-bulk-dialog.html',
  styleUrl: './upload-bulk-dialog.scss',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    NgOptimizedImage,
    MatProgressBar,
    EditTrackComponent,
  ],
})
export class UploadBulkDialog {
  readonly dialogRef = inject(MatDialogRef<UploadBulkDialog>);

  readonly data = inject<{
    genresList: Genre[],
    subgenresList: Genre[],
  }>(MAT_DIALOG_DATA);

  @ViewChild('fileInput')
  fileInput: ElementRef<HTMLInputElement> | undefined;


  mode: 'ready' | 'loading' | 'loaded' = 'ready';
  loadingProcess = 0;
  errorMessage = '';

  tracks: TrackData[] = [];

  models: TrackModel[] = [];
  sessionId = '';

  isProgressReceived = false;
  timeoutId = 0;

  private service = inject(TracksManagerService);

  // constructor(private store: TracksManagerStore) {
  // }

  // private fileStorage = inject(FilesStorageService);

  triggerFileInput(): void {
    this.fileInput?.nativeElement.click();
  }

  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const files = Array.from(input?.files || []);

    if (files.length) {
      this.uploadFiles(files);
    }
  }

  onFileDrop(event: DragEvent): void {
    event.preventDefault();
    const files = Array.from(event.dataTransfer?.files || []);
    if (files.length) {
      this.uploadFiles(files);
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
  }

  setTracksEditData(data: TrackApiData[]) {
    // const tracks = data.map((track: TrackApiData) => {
    //   return {
    //     title: track.title,
    //     artists: track.artists?.map(item => item.artist) || [],
    //     genre: track.genre,
    //     subgenre: track.subgenre,
    //     bpm: track.bpm || 100,
    //     releaseDate: track.releaseDate || Date.now(),
    //     fileName: track.fileName
    //     // duration
    //   }
    // });

    const {tracks, models} = data.reduce((acc: {tracks: TrackData[], models: TrackData[]}, track: TrackApiData) => {
        const item = {
          title: track.title,
          artists: track.artists || '',
          genre: track.genre,
          subgenre: track.subgenre,
          // currentArtist: '',
          bpm: track.bpm || 100,
          releaseDate: track.releaseDate || new Date(),
          fileName: track.fileName
          // duration
        } as TrackData;
        acc.models.push(item);
        acc.tracks.push(item);
      return acc;
    }, {tracks: [], models: []})

    // const models = data.map((track: TrackApiData) => {

    // });

    this.tracks = tracks as TrackData[];
    this.models = models as TrackModel[];

    // console.log('upload-bulk-dialog.ts => setTracksEditData: ', this.sessionId, list);

    // this.track.set();
  }

  fakeProgress() {
    this.timeoutId = setTimeout(() => {
      if (this.isProgressReceived || this.loadingProcess > 80) {
        return;
      }
      const progressInc = Math.floor(Math.random() * 14) + 1;
      this.loadingProcess += progressInc;
      this.fakeProgress();
    }, 1000);
  }

  uploadFiles(files: File[]): void {
    this.errorMessage = '';
    if (files.length > MAX_FILES_ALLOWED) {
      this.errorMessage = `Maximum ${MAX_FILES_ALLOWED} files allowed at once`;
      return;
    }
    this.mode = 'loading';

    console.log('upload-bulk-dialog.ts => uploadFiles: ', );

    this.fakeProgress();

    this.service.uploadFiles(files)?.pipe(
      map((event: HttpEvent<any>) => {
        console.log('upload-bulk-dialog.ts => : ', event);
        switch (event.type) {
          case HttpEventType.Sent:
            // console.log('Request sent!');
            break;
          case HttpEventType.UploadProgress:

            this.loadingProcess = Math.round(100 * event.loaded / (event.total || 1));
            console.log(`Uploading: ${ this.loadingProcess }%`);
            this.isProgressReceived = true;
            clearTimeout(this.timeoutId);
            break;
          case HttpEventType.Response:
            clearTimeout(this.timeoutId);
            this.sessionId = event.body.sessionId;

            this.setTracksEditData(event.body?.tracks);

            this.mode = 'loaded';
            break;
        }
        return event; // Pass the event along for further processing if needed
      })
    ).subscribe();
  }

  save() {
    this.dialogRef.close({
      sessionId: this.sessionId,
      tracks: this.models
    })
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

